// src/components/Confirmation.js
import React, { useEffect, useState, useContext } from "react";

import Footer from "./Footer";
import BackToTopButton from "./BackToTop";

//import "./conformpage.css";
import { CarrierContext } from "../contexts/CarrierContext";
import { LanguageContext } from "../contexts/LanguageContext";
import HeaderPayment from "./HeaderPayment";
import Breadcrumbs from "./Breadcrumbs";
import { dompurifyHtml } from "../utils/sanitizeInput";

const LanguageProficiency = () => {
  const carrierContxt = useContext(CarrierContext);
  const urlCarrier = carrierContxt.hasOwnProperty("carrier")
    ? carrierContxt.carrier
    : null;

  const { cmsAllPages, handleLanguage, langErr } = useContext(LanguageContext);
  const [cms, setConfirmationCMS] = useState("");
  const [langSelected, setLangSelected] = useState(
    () => sessionStorage.getItem("langSel") || "eng"
  ); // default language

  useEffect(() => {
    if (cmsAllPages && cmsAllPages.language_proficiency) {
      setConfirmationCMS(cmsAllPages.language_proficiency);
    }
  }, [cmsAllPages, setConfirmationCMS]);

  //Autocomplete

  const [query, setQuery] = useState("");
  const [filteredLanguages, setFilteredLanguages] = useState([]);

  // Define the language data with names and their respective content
  /*const languages =  [
    {
      name: "English",
      content:
        'This notice contains important information about your application or coverage. Pay attention to the key dates contained in this notice. You may need to take some action before certain dates to keep your health coverage or get help with costs. You are entitled to receive this information and language assistance at no cost. For language assistance, go to the <a href="https://uat.servicelinkportal.com/contact_us">Contact Us Page</a> and call Customer Service.',
    },
    {
      name: "Shqiptar - Albanian",
      content:
        'Ky njoftim përmban informacion të rëndësishëm për aplikimin ose mbulimin tuaj. Kushtojini vëmendje datave kryesore që përmban ky njoftim. Mund t\'ju duhet të ndërmerrni ndonjë veprim përpara datave të caktuara për të mbajtur mbulimin tuaj shëndetësor ose për ndihmën me kostot. Keni të drejtë ta merrni falas këtë informacion dhe ndihmën gjuhësore. Për ndihmë gjuhësore, shkoni në faqen <a href="https://uat.servicelinkportal.com/contact_us">Na kontaktoni</a> dhe telefononi shërbimin ndaj klientit.',
    },
    {
      name: "አማርኛ - Amharic",
      content:
        'ይህ ማሳሰቢያ ስለ ማመልከቻዎ ወይም ሰለሚሰጥዎ ሽፋን ጠቃሚ መረጃ የያዘ ነው። በዚህ ማሳሰቢያ ውስጥ የሚገኙትን ዋና ዋና ቀናት ልብ ይበሉ። የጤና ሽፋንዎን ለማስጠበቅ እና ለሚኖርብዎት ወጪዎች እርዳታ ለማግኘት ከተወሰኑት ቀናቶች በፊት አንድ አንድ እርምጃዎችን መውሰድ ሊኖርብዎ ይችላል። ይህንን መረጃ እና የቋንቋ እርዳታ ያለ ምንም ወጪ የማግኘት መብት አለዎት። ለቋንቋ እርዳታ ወደ <a href="https://uat.servicelinkportal.com/contact_us">Contact Us</a> ገጽ ገብተው ወደ Customer Service (የደንበኞች አገልግሎት) ይደውሉ።',
    },
    {
      name: "العربية - Arabic",
      content:
        "يحتوي هذا الإخطار على معلومات مهمة حول طلبك أو التغطية الخاصة بك. انتبه للتواريخ المهمة المذكورة هذا الإخطار. قد تحتاج إلى اتخاذ إجراء ما قبل تواريخ معينة للاحتفاظ بتغطيتك الصحية أو للحصول على مساعدة فيما يخص التكاليف. يحق لك تلقي هذه المعلومات والمساعدة للغوية مجانًا. للحصول على المساعدة اللغوية، اذهب إلى صفحة ‏(Contact Us)‏ اتصل بن واتصل بخدمة العملاء.",
    },
    {
      name: "Հայերեն - Armenian",
      content:
        'Այս ծանուցումը պարունակում է Ձեր դիմումի կամ ծածկույթի վերաբերյալ կարևոր տեղեկատվություն: Ուշադրություն դարձրեք այս ծանուցման մեջ նշված կարևոր ժամկետներին: Հնրարավոր է, որ մինչև որոշակի ժամկետները որոշ գործողություններ ձեռնարկելու անհրաժեշտություն առաջանա` Ձեր բժշկական ապահովագրությունը պահպանելու կամ ծախսերի հետ կապված օգնություն ստանալու համար: Դուք իրավունք ունեք այս տեղեկատվությունն ու լեզվական աջակցությունը ստանալ անվճար: Լեզվական աջակցության համար այցելեք <a href="https://uat.servicelinkportal.com/contact_us">Դիմել մեզ</a> էջը կամ զանգահարեք Հաճախորդների սպասարկման ծառայություն:',
    },
  ];*/
  const languages = cms?.language_menu ? JSON.parse(cms.language_menu) : "";

  // Handle input changes and filter languages based on the query
  const handleChange = (event) => {
    const input = event.target.value;
    setQuery(input);

    if (input === "") {
      setFilteredLanguages([]);
    } else {
      const filtered = languages.filter((language) =>
        language.name.toLowerCase().includes(input.toLowerCase())
      );
      setFilteredLanguages(filtered);
    }
  };

  return (
    <>
      <div>
        <div id={`header-${urlCarrier}`}>
          <HeaderPayment
            page="language_proficiency"
            setLangSelected={setLangSelected}
          ></HeaderPayment>
        </div>
        <main id="main" className="main">
          <div>
            <Breadcrumbs cms={cms}></Breadcrumbs>
          </div>
          <div className="container-lg">
            <div className="payment px-4 mt-3 mb-5">
              <h2 className="heading2" tabIndex="0">{cms.label_language_access_search} </h2>
            </div>

            <section className="bg-white px-3">
              {Array.isArray(languages) && (
                <div className="lang-search mb-4 mt-3" tabIndex="0">
                  <input
                    type="text"
                    className="form-control lang-input"
                    placeholder="Language..."
                    value={query}
                    onChange={handleChange}
                  />
                  <i className="fe fe-search lang-icon"></i>
                </div>
              )}

              <div className="col-12 d-flex flex-wrap content-gloss border-bottom pb-5">
                <div className="col-12 col-md-6">
                  {Array.isArray(languages) && (
                    <div
                      className="accordion accordion-flush"
                      id="accordionFlushExample"
                    >
                      {Array.isArray(filteredLanguages) &&
                      filteredLanguages.length > 0
                        ? filteredLanguages.map((language, index) => (
                            <div
                              className="accordion-item mt-2 rounded-2"
                              key={index}
                            >
                              <h2 className="accordion-header">
                                <button
                                  className="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target={`#flush-collapse${index}`}
                                  aria-expanded="false"
                                  aria-controls={`flush-collapse${index}`}
                                  dangerouslySetInnerHTML={{
                                    __html: dompurifyHtml(language?.name),
                                  }}
                                >
                                  {/* {language.name} */}
                                </button>
                              </h2>
                              <div
                                id={`flush-collapse${index}`}
                                className="accordion-collapse collapse"
                                data-bs-parent="#accordionFlushExample"
                              >
                                <div className="accordion-body" tabIndex="0">
                                  <p
                                    className="lh-lg"
                                    dangerouslySetInnerHTML={{
                                      __html: dompurifyHtml(language?.content),
                                    }}
                                  ></p>
                                </div>
                              </div>
                            </div>
                          ))
                        : Array.isArray(languages) &&
                          languages.map((language, index) => (
                            <div
                              className="accordion-item mt-2 rounded-2"
                              key={index}
                            >
                              <h2 className="accordion-header">
                                <button
                                  className="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target={`#flush-collapse${index}`}
                                  aria-expanded="false"
                                  aria-controls={`flush-collapse${index}`}
                                  dangerouslySetInnerHTML={{
                                    __html: dompurifyHtml(language?.name),
                                  }}
                                >
                                  {/*{language.name}*/}
                                </button>
                              </h2>
                              <div
                                id={`flush-collapse${index}`}
                                className="accordion-collapse collapse"
                                data-bs-parent="#accordionFlushExample"
                              >
                                <div className="accordion-body" tabIndex="0">
                                  <p
                                    className="lh-lg"
                                    dangerouslySetInnerHTML={{
                                      __html: dompurifyHtml(language?.content),
                                    }}
                                  ></p>
                                </div>
                              </div>
                            </div>
                          ))}
                    </div>
                  )}
                </div>
                <div
                  className="col-12 col-md-6 mt-4 mt-md-0 ps-md-4"
                  tabIndex="0"
                  dangerouslySetInnerHTML={{
                    __html: dompurifyHtml(
                      cms.language_section_non_descrimination_notice
                    ),
                  }} // Render HTML content
                />
              </div>
              <div
                className="content-gloss mt-s2 px-3 mt-5"
                id="HHSCivil"
                tabIndex="0"
                dangerouslySetInnerHTML={{
                  __html: dompurifyHtml(cms.language_section_contact_us),
                }} // Render HTML content
              />
            </section>
          </div>
        </main>

        <BackToTopButton></BackToTopButton>

        <Footer cms={cms}></Footer>
      </div>
    </>
  );
};

export default LanguageProficiency;
